var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_298_2613)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#95C11F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.64,
    d: "M11.8776 13.2892L9.97008 15.1967C9.76008 15.01 9.55591 14.8175 9.35758 14.6192C8.75675 14.0125 8.21425 13.3767 7.73008 12.7117C7.25175 12.0467 6.86675 11.3817 6.58675 10.7225C6.30675 10.0575 6.16675 9.42166 6.16675 8.81499C6.16675 8.41832 6.23675 8.03916 6.37675 7.68916C6.51675 7.33332 6.73841 7.00666 7.04758 6.71499C7.42091 6.34749 7.82925 6.16666 8.26091 6.16666C8.42425 6.16666 8.58758 6.20166 8.73341 6.27166C8.88508 6.34166 9.01925 6.44666 9.12425 6.59832L10.4776 8.50582C10.5826 8.65166 10.6584 8.78582 10.7109 8.91416C10.7634 9.03666 10.7926 9.15916 10.7926 9.26999C10.7926 9.40999 10.7517 9.54999 10.6701 9.68416C10.5942 9.81832 10.4834 9.95832 10.3434 10.0983L9.90008 10.5592C9.83591 10.6233 9.80675 10.6992 9.80675 10.7925C9.80675 10.8392 9.81258 10.88 9.82425 10.9267C9.84175 10.9733 9.85925 11.0083 9.87091 11.0433C9.97591 11.2358 10.1567 11.4867 10.4134 11.79C10.6759 12.0933 10.9559 12.4025 11.2592 12.7117C11.4692 12.9158 11.6734 13.1142 11.8776 13.2892Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8159 15.6925C17.8159 15.8558 17.7868 16.025 17.7284 16.1883C17.7109 16.235 17.6934 16.2817 17.6701 16.3283C17.5709 16.5383 17.4426 16.7367 17.2734 16.9233C16.9876 17.2383 16.6726 17.4658 16.3168 17.6117C16.3109 17.6117 16.3051 17.6175 16.2993 17.6175C15.9551 17.7575 15.5818 17.8333 15.1793 17.8333C14.5843 17.8333 13.9484 17.6933 13.2776 17.4075C12.6068 17.1217 11.9359 16.7367 11.2709 16.2525C11.0434 16.0833 10.8159 15.9142 10.6001 15.7333L12.5076 13.8258C12.6709 13.9483 12.8168 14.0417 12.9393 14.1058C12.9684 14.1175 13.0034 14.135 13.0443 14.1525C13.0909 14.17 13.1376 14.1758 13.1901 14.1758C13.2893 14.1758 13.3651 14.1408 13.4293 14.0767L13.8726 13.6392C14.0184 13.4933 14.1584 13.3825 14.2926 13.3125C14.4268 13.2308 14.5609 13.19 14.7068 13.19C14.8176 13.19 14.9343 13.2133 15.0626 13.2658C15.1909 13.3183 15.3251 13.3942 15.4709 13.4933L17.4018 14.8642C17.5534 14.9692 17.6584 15.0917 17.7226 15.2375C17.7809 15.3833 17.8159 15.5292 17.8159 15.6925Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_298_2613"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.092762db8bf38d8d66a50db20a8a874c.svg";
export { ForwardRef as ReactComponent };